const OUTCOMES = [
  { id: "success", label: "SUCCESS", color: "text-emerald-300", badge: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40", desc: "Extraction and financial validation completed with the required information reconciled successfully." },
  { id: "review", label: "REVIEW", color: "text-amber-300", badge: "bg-amber-500/20 text-amber-300 border-amber-500/40", desc: "The report contains a non-reconciling or ambiguous result that needs controlled human review instead of silent acceptance." },
  { id: "failed", label: "FAILED", color: "text-red-300", badge: "bg-red-500/20 text-red-300 border-red-500/40", desc: "A genuine processing failure occurred, such as an unreadable PDF or an unrecoverable processing/storage error after safeguards." },
];

const CHECKS = [
  "Required CIB fields are extracted from the report",
  "Reporting and financial values are validated before classification",
  "Financial reconciliation is checked before SUCCESS",
  "Non-reconciling results are preserved as REVIEW rather than silently accepted",
  "Database-save failures are retried before a PDF is considered failed",
];

export default function ValidationReview() {
  return (
    <div className="space-y-4">
      <div>
        <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">VALIDATION & REVIEW</p>
        <h4 className="mt-1 text-sm font-semibold text-white">Financial consistency before final classification</h4>
        <p className="mt-1 text-xs text-slate-400">The platform separates extraction from business validation so concurrent processing changes throughput, not the rules used to decide whether a report is correct.</p>
      </div>

      <div className="grid gap-2 md:grid-cols-3">
        {OUTCOMES.map((o) => (
          <div key={o.id} className={`rounded-xl border p-3 ${o.badge}`}>
            <p className={`text-sm font-bold ${o.color}`}>{o.label}</p>
            <p className="mt-1 text-[11px] leading-relaxed text-slate-400">{o.desc}</p>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-white/10 bg-black/20 p-3">
        <p className="mb-2 font-mono text-[9px] tracking-[0.15em] text-slate-500">CONSISTENCY CHECKS</p>
        <div className="space-y-1.5">
          {CHECKS.map((x) => (
            <div key={x} className="flex items-start gap-2 rounded-lg border border-white/10 bg-white/5 px-2.5 py-2">
              <span className="mt-0.5 shrink-0 text-purple-300">›</span>
              <p className="text-[11px] text-slate-400">{x}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-xl border border-amber-500/20 bg-amber-500/5 p-3">
        <p className="font-mono text-[10px] tracking-[0.2em] text-amber-400">HUMAN REVIEW</p>
        <p className="mt-1 text-[11px] leading-relaxed text-slate-400">Review is intentionally a first-class outcome. A report that does not reconcile exactly is not silently converted into SUCCESS just because the system is processing concurrently.</p>
      </div>
    </div>
  );
}
